

<template>
  <!-- :style="this.$route.name === 'default' ? '' : 'border-top:3px solid rgb(224, 2, 38)'" -->
  <footer  v-if="userFullName == '' || this.$route.name === 'default'"  class="d-print-none" >
<!-- <footer class="footer "> -->

          <div class="d-none d-md-block" >
            <div class="container-fluid" >

              <div  style="padding:60px 40px 20px 40px;background-color:#f0f2f5;">

                      <div class="row">
                          <div class="col-12 col-lg-2 text-left">
                            <img src="@/assets/images/logo.png" alt height="100" />
                            <div class="mt-2">
                              <span style="font-size: 14px;
                                  font-style: normal;
                                  font-weight: 400;
                                  line-height: 24px; text-align:justify;" class="text-dark"> DigiTable est une solution tout-en-un pour gérer vos menus, commandes, paiements et fidélisation de manière simple et efficace. </span>
                            </div>

                            <div class="mt-4">
                              <footersocial/>  
                            </div>
                          </div>

                          <div class="col-12 col-lg-10">

                              <div class="row">
                                    <div class="col-1 col-md-2 col-lg-3 col-xl-4 d-none d-lg-flex"/>
                                    <div class="col-12 col-md-3 col-lg-3 ">
                                          <div class="m-3">
                                            <span class="text-dark font-weight-bold" style="font-size: 14px;
                                              font-style: normal;
                                              font-weight: 500;
                                              line-height: 24px;"> Accès rapide</span>
                                          </div>

                                          <FooterQuickaccess/>
                                          
                                    </div>

                                    <div class="col-12 col-md-3">
                                          <div class="m-3">
                                            <span class="text-dark font-weight-bold" style="font-size: 14px;
                                              font-style: normal;
                                              font-weight: 500;
                                              line-height: 24px;"> Informations</span>
                                          </div>

                                          <footerinfo/>
                                    </div>

                                    <div class="col-12 col-md-3 col-xl-2">
                                          <div class="m-3">
                                            <span class="text-dark font-weight-bold" style="font-size: 14px;
                                              font-style: normal;
                                              font-weight: 500;
                                              line-height: 24px;"> DigiTable</span>
                                          </div>

                                          <FooterPubAg/>
                                    </div>

                              </div>

            
              </div>
      </div>


      <div class="row pt-4" style="border-top: 1px solid var(--black-300, #CBCBCB);">
        <div class="col-md-6 col-12  text-md-left text-center">

          <span class="text-info font-size-14 " style="font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px; ">© {{ new Date().getFullYear() }} DigiTable Copyright 
          </span>

        </div>

        <div class="col-md-6 col-12 mt-md-0 mt-2  text-md-right text-center">
          <div class="text-right text-dark mb-md-1 mb-2">
              <footerregion/>
          </div>

            <a href="/" class="text-info mt-2" style="color:#92B9B1" target="_blank">Digitable<small class="ml-2">{{ prodversion }}</small></a>

        </div>
      </div>
</div>
      



</div>
      </div>


     

   
   
  </footer>

  <footer v-else  class="footer  p-1" style="background-color:#92B9B1" :class="this.$route.name === 'default' ? 'd-none' : 'bg-light'" >
    <div class="container-fluid">

      <div class="row pr-3 pl-3" style="margin: auto;">
        <div class="col-lg-12 col-sm-12 text-center">
          <span class=" font-size-14 font-weight-bold text-dark mr-1" style="color:#92B9B1">Copyright {{ new Date().getFullYear() }} © Tous droits réservés</span>
          <!-- - Amiral, Sté Incendo  -->
          <span class="font-size-14 text-dark " style="color:#92B9B1"><a href="/" class="text-dark" style="color:#92B9B1" target="_blank">Digitable<small class="ml-2">{{ prodversion }}</small></a></span>
        </div>
          
      </div>
    </div>
   
  </footer>



</template>

<script>
import FooterQuickaccess from "@/components/footer-quick-access.vue"
import footerinfo from "@/components/footer-info.vue"
import FooterPubAg from "@/components/footer-pubAg.vue"
import footerregion from "@/components/footer-region.vue"
import footersocial from "@/components/footer-social.vue"



export default ({
  name: "Faq",

  components: {
    FooterQuickaccess, footerinfo, FooterPubAg, footersocial, footerregion
  },

  computed: {
    userFullName() {
      return this.$cookies.isKey('userFullName') ? this.$cookies.get('userFullName') : '';      
    },

  },

  data() {
    return {
      prodversion: 'v5.2.24',
    };
  },

  methods: {},
      
});
</script>
